import React from "react";
import BackgroundImage from "src/components/backgroundImage/backgroundImage.v1";

export default class ExternalVideoFacade extends React.Component<TVideoComponentProps> {
  render(): React.ReactNode {
    const aspect = this.props.asBackground ? '' : 'aspect-[16/9]';
    return <div className={`w-full h-full ${aspect} bg-slate-200 relative cursor-pointer`}>
      <BackgroundImage mobileContain className="h-full w-full" src={this.props.placeholder} />
    </div>
  }
}